import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  // @ts-ignore: Property has no initializer and is not definitely assigned
  private authStatusSub: Subscription;
  public isLoading = false;
  public errorMessage = '';

  constructor(private authService: AuthService, private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation?.extras.state as { data: string };
      this.errorMessage = state.data;
    }
  }

  ngOnDestroy(): void {
    this.authStatusSub.unsubscribe();
  }

  ngOnInit(): void {
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((authStatus) => {
        this.isLoading = false;
      });
  }

  onSubmit(form: NgForm): void {
    console.log(form);
    if (!form.invalid) {
      this.isLoading = true;
      this.authService.login(form.value.email, form.value.password);
    }
  }

  setErrorMessage(error: string): void {
    this.errorMessage = error;
  }
}
